<template>
  <custom-popover ref="extraVarsPopover" class="template-extra-variables-popover" :backdrop="true">
    <div class="popover-header">
      <div class="left-side-header">
        <h2>{{ $t("extra-variables.title") }}</h2>
      </div>
      <div class="close-popover" @click.stop.prevent="onClose()">
        <i class="fa-light fa-times"></i>
      </div>
    </div>
    <div class="extra-variables-wrapper">
      <div class="left custom-scrollbar-light" :class="{ 'left-popover-open': showVars }">
        <div class="search-filter" v-show="!showVars">
          <custom-input
            ref="searchInput"
            class="search-input"
            :inputType="'text'"
            v-model="searchFilter"
            :name="'searchInput'"
            :label="$t('search') + ' ' + $t('extra-variables.title')"
            :placeholder="$t('search') + '...'"
          />
          <!-- <input  type="text" class="search-input synonym-filter" v-bind:placeholder="$t('search')+'...'" v-model="searchFilter"/> -->
          <div v-show="!showVars" class="search-icon">
            <i class="fa-light fa-search"> </i>
          </div>
        </div>
        <div class="extra-variables-list" v-if="!showVars">
          <div v-if="extraVariables.length == 0" class="no-vars">
            <span>{{ $t("extra-variables.empty-list") }}</span>
          </div>
          <div v-if="filteredExtraVariableList.length == 0 && extraVariables.length > 0" class="no-vars">
            <span style="margin: 0 auto">{{
              $t("extra-variables.empty-list-search1") + searchFilter + $t("extra-variables.empty-list-search2")
            }}</span>
          </div>
          <div
            v-else
            class="extra-variable"
            v-for="(extraVariable, index) in filteredExtraVariableList"
            :key="index"
            @click="(selectedVariable = filteredExtraVariableList[index]), (createVariableClicked = false)"
            :class="{ 'is-selected': extraVariable == selectedVariable }"
          >
            <div class="flex-grow-1">
              <div>
                {{
                  extraVariable.name.includes("_")
                    ? extraVariable.name.substring(
                        extraVariable.name.lastIndexOf("_") + 1,
                        extraVariable.name.length - 1
                      )
                    : extraVariable.name.substring(1, extraVariable.name.length - 1)
                }}
              </div>
              <!-- <div class="text-muted">{{extraVariable.expression ? 'Standard ' : 'If-then'}}</div> -->
              <div class="text-muted">
                {{
                  extraVariable.name.includes("_")
                    ? extraVariable.name.substring(1, extraVariable.name.lastIndexOf("_")).replaceAll("_", " → ")
                    : $t("extra-variables.no-category")
                }}
              </div>
            </div>
            <div>
              <span
                class="duplicate-btn"
                @click="duplicateExtravariable(extraVariable, index)"
                tooltip-placement="left"
                :tooltip="$t('duplicate')"
              >
                <i class="fa-light fa-clone"></i>
              </span>

              <span class="selected-chevron">
                <i class="fa-light fa-chevron-right"></i>
              </span>
            </div>
          </div>
        </div>
        <div class="backdrop-vars" v-if="showVars" @click.self.prevent.stop="handleBackdrop"></div>
        <transition name="slide">
          <div class="popover-step" v-if="showVars">
            <div v-if="variableGroups && !loading">
              <variable-selector
                class="variable-list"
                :variable-groups="variableGroups"
                :variableTypeFilters="typeFilter"
                :show-values="false"
                :selectedVariableName="selectedTemplateVariable"
                @variable-name-changed="handleVariableSelect"
              />
              <!-- :groups-only="true" this is for the path selection in Extra variables -->
            </div>
            <div v-show="loading" style="margin-top: 30px" class="text-center text-muted">
              <i class="fa-light fa-circle-notch fa-spin"></i>
            </div>
            <div class="actions">
              <button
                class="add-to-expression btn btn-small btn-primary"
                :disabled="!selectedTemplateVariable"
                @click="addToExpression"
              >
                {{ $t("extra-variables.add") }}
              </button>
              <button class="cancel btn btn-small btn-secondary" @click="showVars = !showVars">
                {{ $t("extra-variables.cancel") }}
              </button>
            </div>
          </div>
        </transition>
      </div>
      <button
        v-if="!showVars"
        class="btn btn-primary create-btn"
        @click="(createVariableClicked = createVariableClicked = true), (selectedVariable = null)"
      >
        {{ $t("extra-variables.create-btn") }}
      </button>

      <div class="right custom-scrollbar-light">
        <create-extra-variable
          v-if="createVariableClicked"
          @get-variable-groups="getVars"
          :extraVariables="extraVariables"
          @create-and-close="
            (createVariableClicked = false),
              (selectedVariable = extraVariables[extraVariables.length - 1]),
              updatePreview()
          "
        />
        <edit-extra-variable
          v-if="selectedVariable"
          @detect-changes="hasChanges = true"
          @get-variable-groups="getVars"
          :selectedVariable="selectedVariable"
          @delete-var="deleteExtraVariable"
          @update-var="updateExtraVariable"
          :varType="
            selectedVariable.expression
              ? selectedVariable.mappings && Object.keys(selectedVariable.mappings).length != 0
                ? 'Dictionary'
                : 'Standard'
              : 'If'
          "
        />
      </div>
      <div v-if="selectedVariable" class="save-footer-extra-vars">
        <button @click="handleSave" class="btn btn-primary btn-flex" :disabled="!hasChanges">
          {{ $t("extra-variables.save") }}
        </button>
        <button @click="deleteExtraVariable" class="btn btn-secondary btn-flex">
          {{ $t("extra-variables.delete") }}
        </button>
      </div>
    </div>
  </custom-popover>
</template>

<script>
import CustomInput from "@/components/CustomInput";
import CustomPopover from "@/components/CustomPopover";
import EditExtraVariable from "@/components/EditExtraVariable";
import CreateExtraVariable from "@/components/CreateExtraVariable";
import VariableSelector from "@/components/VariableSelector";
import EventBus from "@/assets/js/eventBus.js";
import ConfirmModal from "@/components/modals/ConfirmModal";
import variableHelpers from "@/assets/js/variableHelpers.js";
import orderBy from "lodash/orderBy";
export default {
  name: "templateExtraVariablesPopover",
  data() {
    return {
      selectedType: "",
      createVariableClicked: false,
      selectedVariable: null,
      popoverStyle: {},
      variables: null,
      loading: null,
      showVars: false,
      selectedTemplateVariable: null,
      hasChanges: false,
      searchFilter: "",
      typeFilter: []
    };
  },
  methods: {
    duplicateExtravariable(extraVariable, index) {
      let newName = variableHelpers.setBrackets(extraVariable.name);
      let i = 0;
      while (this.extraVariables.some((v) => v.name == newName)) {
        i++;
        newName = variableHelpers.setBrackets(`${extraVariable.name} (${i})`);
      }

      const newExtraVariable = { ...extraVariable, name: newName };
      const newIndex = index + 1;
      this.extraVariables.splice(newIndex, 0, newExtraVariable);

      this.selectedVariable = newExtraVariable;
      this.$store.state.unsavedChanges = true;
    },

    focusSearch() {
      this.$nextTick(function() {
        this.$refs.searchInput.focus();
      });
    },
    handleSave() {
      EventBus.$emit("save-extra-variable");
      this.hasChanges = false;
    },
    editVariable(index) {
      this.selectedVariable = this.extraVariables[index];
    },
    updateExtraVariable(extraVariable, newName) {
      let varToUpdate = this.extraVariables.findIndex((v) => v.name == extraVariable.name);
      if (newName) {
        extraVariable.name = `{${newName}}`;
      }

      this.selectedVariable = extraVariable;
      this.$set(this.extraVariables, varToUpdate, extraVariable);
      this.$store.state.unsavedChanges = true;
      this.updatePreview();
    },
    onClose() {
      this.$emit("close");
    },
    getVars(filters) {
      this.showVars = true;
      this.typeFilter = filters;
      this.variables = null;
    },
    handleVariableSelect(selectedTemplatevar) {
      this.selectedTemplateVariable = selectedTemplatevar;
    },
    addToExpression() {
      EventBus.$emit("add-to-expression", this.selectedTemplateVariable);
      this.showVars = false;
      // this.extraVariable.expression = this.extraVariable.expression + this.selectedTemplateVariable
    },

    deleteExtraVariable() {
      this.$modal.show(
        ConfirmModal,
        {
          title: this.$t("extra-variables.delete-title"),
          description:
            this.$t("extra-variables.delete-desc") +
            ` ${
              this.selectedVariable.name.includes("_")
                ? this.selectedVariable.name.substring(
                    this.selectedVariable.name.lastIndexOf("_") + 1,
                    this.selectedVariable.name.length - 1
                  )
                : this.selectedVariable.name.substring(1, this.selectedVariable.name.length - 1)
            }?`,
          confirmButtonText: this.$t("extra-variables.delete-btn"),
          onConfirm: (result) => {
            this.extraVariables.splice(this.extraVariables.findIndex((v) => v.name == this.selectedVariable.name), 1);
            this.selectedVariable = null;
            this.$store.state.unsavedChanges = true;
            this.updatePreview();
            this.selectedVariable = this.extraVariables[this.extraVariables.length - 1];
          }
        },
        { width: 310, height: "auto", adaptive: true }
      );
    },
    updatePreview() {
      this.$store
        .dispatch("getTemplatePreview", {
          template: this.$store.state.template,
          variables: this.$store.state.templateVariables
        })
        .then((preview) => {
          // this.$store.state.templatePreview = preview;
          this.$store.commit("setTemplatePreview", preview);
        });
    },
    handleBackdrop() {
      EventBus.$emit("vars-closed");
      this.showVars = false;
    }
  },
  computed: {
    extraVariables() {
      return this.$store.state.template.extraVariables;
    },
    variableGroups() {
      return this.$store.getters.variableGroups;
    },

    // This function is messing with build, currenlt disabled.
    filteredExtraVariableList() {
      return orderBy(
        this.extraVariables.filter((v) => v.name.toLowerCase().includes(this.searchFilter.toLowerCase())),
        [(v) => v.name.toLowerCase()],
        ["asc"]
      );
    }
  },
  mounted() {
    this.focusSearch();
    if (this.extraVariables) {
      this.selectedVariable = this.extraVariables[0];
    }
  },
  watch: {
    selectedVariable: {
      handler: function(val, oldVal) {
        this.hasChanges = false;
      }
    },
    showVars: {
      handler: function() {
        if (this.showVars == false) this.typeFilter = null;
      }
    }
  },
  components: {
    CustomPopover,
    EditExtraVariable,
    VariableSelector,
    CreateExtraVariable,
    CustomInput
  }
};
</script>

<style lang="less">
.template-extra-variables-popover {
  width: 840px;
  // height: 500px;
  line-height: 1.5;
  background-color: #fff;
  position: absolute;
  color: #3d464a;
  &.custom-popover {
    background-color: #fff;
    right: calc(50% - (840px / 2));
    left: unset;
    top: calc(50% - (500px / 2));
    &::before {
      // content: url(*/svg/close.svg);
      display: none;
    }

    .close-button {
      display: none;
    }
  }
  .popover-header {
    h2 {
      margin: 0;
      color: var(--charcoal);
    }
  }

  .extra-variable {
    display: flex;
    align-items: center;
    padding: 5px 12px;
    cursor: pointer;

    span {
      flex-grow: 1;
    }
    .duplicate-btn {
      opacity: 0;
      margin-right: 12px;
    }
    .selected-chevron {
      opacity: 0;
      font-size: 12px;
    }
    &:hover {
      background-color: rgba(219, 218, 218, 0.4);

      .duplicate-btn,
      .selected-chevron {
        opacity: 1;
      }
    }

    &.is-selected {
      background-color: rgba(219, 218, 218);
      .selected-chevron {
        opacity: 1;
      }
    }
  }

  .extra-variables-wrapper {
    display: grid;
    grid-template-columns: 1fr 1fr;
    background-color: #fff;
    height: 420px;
    border-radius: 0 0 10px 10px;

    .create-btn {
      position: absolute;
      bottom: 0px;
      margin: 12px;
      width: max-content;
    }
    .left,
    .right {
      position: relative;
      overflow: auto;
      height: calc(100% - 50px);
      .search-filter {
        position: relative;
        margin: 0 12px 12px 12px;
        .search-icon {
          position: absolute;
          right: 20px;
          bottom: 8px;
          width: 13px;
        }
        .close-icon {
          position: absolute;
          right: 40px;
          top: 8px;
          width: 13px;
        }
      }
      .popover-step {
        position: relative;
        width: auto;
        .variable-selector.variable-list {
          // animation: slideInVars 0.2s ease;
          width: auto;
          position: relative;
          z-index: 103;
        }
        .variable-list-wrapper {
          overflow: auto;
          max-height: 300px;
        }
        .actions {
          display: flex;
          gap: 12px;
          position: absolute;
          padding: 12px;
          z-index: 103;
        }
      }
    }
    .left.left-popover-open {
      height: unset;
    }
  }

  .backdrop-vars {
    position: fixed;
    z-index: 102;
    height: 100%;
    width: 100%;
    left: 0;
    top: 0;
    //   background-color: rgba(0, 0, 0, 0.25);
  }
  .close-popover {
    color: var(--charcoal);
    cursor: pointer;
  }

  .form-group {
    margin-bottom: 0;

    .form-control {
      // padding: 0px 8px 10px 0;
      &:invalid {
        color: #8f979c;
      }
    }
  }

  .hide {
    opacity: 0;
    pointer-events: none;
  }

  select option:disabled {
    color: red;
  }

  .no-vars {
    text-align: center;
    margin: 20px auto;
    text-align: center;
    font-size: 14px;
    display: flex;
    justify-content: center;
    color: #8f979c;
    letter-spacing: 0.6px;
  }

  // .create-btn::after{
  //     content: "+";
  //     border: 1px solid white;
  //     border-radius: 100%;
  //     width: 20px;
  //     height: 20px;
  //     padding: 0 4px;
  //     margin: 0 0 0 10px;
  // }

  .save-footer-extra-vars {
    position: absolute;
    bottom: 0;
    right: 0;
    display: flex;
    z-index: 1;
    gap: 12px;
    justify-content: flex-end;
    padding: 12px;
    .save,
    .cancel {
      flex: 1 1 auto;
      line-height: 35px;
      cursor: pointer;
      // &:hover {
      // color: #000;
      // }
    }
    .save {
      color: #3d464a70;
      border-left: 1px solid #3d464a5d;
      pointer-events: none;
    }
    &.can-save {
      .save {
        pointer-events: auto;
        color: #3d464a;

        &:hover {
          color: #000;
        }
      }
    }
    svg {
      margin-left: 4px;
    }
  }
  .active-input {
    box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.15);
    background: #fafafa;
    transition: 0.2s;
    transform: scale(1.01);
  }

  .advanced-options {
    .advanced-options-header {
      cursor: pointer;
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 4px;
    }
  }
}

.slide-enter-to {
  position: absolute;
  opacity: 0.5;
  transform: translateX(0);
}
.slide-enter,
.slide-leave-to {
  position: absolute;
  opacity: 0;
  transform: translateX(-30px);
}

.slide-leave-active,
.slide-enter-active {
  position: absolute;
  transition: all 0.1s ease;
}
</style>
